/**
 * The title of the screen the person is on, in their language — the `context.title` a question
 * is sent with (ADR 9080), so the assistant knows what «this figure» refers to.
 *
 * Taken from the navigation's own list of screens (`../feedback/sections.ts`, the one the rail,
 * the palette and the problem report read), so it cannot disagree with the page header. A path
 * that is not a listed screen (a drill under one is resolved to the screen it drills from) and
 * the general fallback have no title: the key is then simply not sent.
 */

import type { TFunction } from 'i18next';

import {
  GENERAL_SECTION, feedbackSections, sectionForPath, type SectionTarget,
} from '../feedback/sections';
import type { ShellTargetAccess } from '../chrome/shell-targets';

export function screenTitle(path: string, access: ShellTargetAccess, t: TFunction): string | undefined {
  const sections: readonly SectionTarget[] = feedbackSections(access);
  const id = sectionForPath(path, sections);
  if (id === GENERAL_SECTION) return undefined;
  const section = sections.find((candidate) => candidate.id === id);
  if (section === undefined) return undefined;
  return section.parentLabelKey === undefined
    ? t(section.labelKey)
    : t('nav.subScreen', { screen: t(section.parentLabelKey), view: t(section.labelKey) });
}
